import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const { refresh } = useAuth();
  const [state, setState] = useState(token ? "verifying" : "missing");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!token) return;
      try {
        await api.post("/auth/verify-email", { token });
        await refresh();
        if (!cancelled) setState("ok");
      } catch (err) {
        if (!cancelled) {
          setState("fail");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token, refresh]);

  return (
    <div className="min-h-screen bg-background grain relative flex items-center justify-center px-6">
      <div className="relative z-10 w-full max-w-md text-center">
        <Link to="/" className="inline-flex items-center gap-3 mb-10">
          <div className="w-8 h-8 border border-[#00D4FF] rotate-45 flex items-center justify-center">
            <span className="-rotate-45 text-[#00D4FF] font-mono text-xs font-bold">M</span>
          </div>
          <div className="text-left">
            <div className="font-display text-lg leading-none">Martingale</div>
            <div className="overline leading-none mt-1">PLAYBOOK·TERMINAL</div>
          </div>
        </Link>

        <div className="border border-zinc-800 p-10 bg-zinc-950/40" data-testid={`verify-${state}`}>
          {state === "verifying" && (
            <>
              <div className="overline mb-3">VERIFYING</div>
              <h1 className="font-display text-3xl text-white">Just a moment…</h1>
            </>
          )}
          {state === "ok" && (
            <>
              <div className="overline mb-3 neon-text">VERIFIED</div>
              <h1 className="font-display text-3xl neon-text mb-4">Email confirmed.</h1>
              <p className="text-sm text-zinc-400 mb-6">
                Your account is now fully verified. Morning digests will land in your inbox.
              </p>
              <Link
                to="/app"
                className="inline-block px-6 py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs"
              >
                Open dashboard
              </Link>
            </>
          )}
          {state === "fail" && (
            <>
              <div className="overline mb-3 amber-text">LINK EXPIRED</div>
              <h1 className="font-display text-3xl amber-text mb-4">
                Verification link invalid.
              </h1>
              <p className="text-sm text-zinc-400 mb-6">
                Log in and request a fresh one from your profile.
              </p>
              <Link
                to="/login"
                className="inline-block px-6 py-3 border border-zinc-700 font-mono uppercase tracking-widest text-xs hover:border-[#00D4FF] hover:text-[#00D4FF]"
              >
                Go to login
              </Link>
            </>
          )}
          {state === "missing" && (
            <>
              <div className="overline mb-3 amber-text">NO TOKEN</div>
              <h1 className="font-display text-3xl amber-text">
                Verification link is missing.
              </h1>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
